import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './index.css';

// TODO: this is a duplicate of Modal component from

function Modal({ children, className, onClose }) {
  return (
    <div className={classNames('Modal', className)} onClick={onClose}>
      <div onClick={e => e.stopPropagation()}>{children}</div>
    </div>
  );
}

Modal.propTypes = {
  children: PropTypes.element.isRequired,
  className: PropTypes.string,
  onClose: PropTypes.func,
};

Modal.defaultProps = {
  className: undefined,
  onClose: () => null,
};

export default Modal;



// WEBPACK FOOTER //
// ../ui-components/components/ModalNew/index.jsx